<template>
  <div class="qw-dislist">
    <div class="qd-container">
      <van-sticky>
        <div class="qd-head">
          <van-button icon="add-o" type="info" @click="addDis"
            >添加一个默认回复设置</van-button
          >
        </div>
      </van-sticky>

      <div class="qd-list">
        <van-list
          v-model="data.loading"
          :finished="data.finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            class="qd-item"
            v-for="(item, index) in data.datas"
            :key="index"
            @click="editDis(item.channelid)"
          >
            <van-icon name="comment-o" />&nbsp;{{ item.channel_name }}
            <van-tag type="primary" v-if="item.usecount">生效{{item.usecount}}次</van-tag>
            <van-tag mark v-if="item.isenable">已停用</van-tag>
            <van-icon
              v-if="!item.loading"
              name="ellipsis"
              class="qd-item-settle"
              @click.stop="itemMenuEvent(index)"
            />
            <van-loading class="qd-item-loading" v-if="item.loading" />
          </div>
        </van-list>
      </div>
      <div class="mb-tab"></div>
    </div>
      <van-action-sheet
      v-model="itemmenu_show"
      :actions="itemmenu_action"
      cancel-text="取消"
      @select="onItemMenuSelect"
      @cancel="onItemMenuCancel"
    />
    
    <div class="right-tool">
      <div :class="'tool-help'+(showhelptext?' active':'')" @click="goHelp">
        <van-icon name="question" />
        <span class="text">查看帮助</span>
      </div>
    </div>

    
    <!-- 帮助页面 -->
    <van-popup v-model="showhelp" position="bottom" :style="{  height: '90%' }" closeable>
      <lu_actiondetail :noadd="1" :moduleid="5"></lu_actiondetail>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import lu_actiondetail from "./ActionDetail.vue"
import { Button, List, Cell, CellGroup, Icon, Sticky, Tag,
  Dialog,
  Toast, } from "vant";
Vue.use(Button);
Vue.use(List);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Icon);
Vue.use(Sticky);
Vue.use(Tag);
Vue.use(Dialog);
Vue.use(Toast);
export default {
  name: "qd-index",
  data() {
    return {
      data: {
        page: 1,
        datas: [],
        loading: false,
        finished: false,
      },
      list: {
        datas: [],
        page: 1,
      },
      itemmenu_show: false,
      itemmenu_action: [{ name: "编辑" }, { name: "停用" }, { name: "删除" }],
      itemmenu_index: 0,
      
      showhelptext:false,
      showhelp:false,
    };
  },
  methods: {
    
    goHelp(){
      if(this.showhelptext) this.showhelp = true;
      this.showhelptext = !this.showhelptext;
    },
    //取消显示菜单
    onItemMenuCancel() {
      this.itemmenu_show = false;
    },
    //选择某个菜单
    onItemMenuSelect(item) {
      var t = this;
      var channel = t.data.datas[t.itemmenu_index];
      console.log("item", item);
      switch (item.name) {
        case "编辑":
          t.editDis(channel.channelid);
          break;
        case "停用":
          t.enableDis(t.itemmenu_index, true);
          break;
        case "启用":
          t.enableDis(t.itemmenu_index, false);
          break;
        case "删除":
          t.delDis(t.itemmenu_index);
          break;
        default:
          break;
      }
    },
    //每个项的点击菜单
    itemMenuEvent(index) {
      var t = this;
      t.itemmenu_index = index;
      var item = t.data.datas[t.itemmenu_index];
      if (item.isenable) t.itemmenu_action[1].name = "启用";
      else t.itemmenu_action[1].name = "停用";
      t.itemmenu_show = true;
    },
    addDis() {
      this.$router.push({
        path: "/disdetail",
        query: { isdefault: true },
      });
    },
    editDis(id) {
      this.$router.push({
        path: "/disdetail",
        query: { id: id, isdefault: true },
      });
    },
    //编辑
    delDis(index) {
      var t = this;
      Dialog.confirm({
        title: "系统提示",
        message: "删除设置后自动回复等设置将失效，确认删除吗？",
      })
        .then(() => {
          t.itemmenu_show = false;
          var channel = t.data.datas[t.itemmenu_index];
          var loading = Toast.loading({
            message: "加载中...",
            forbidClick: true,
          });
          t.$http
            .post("/Channel/DelChannel", { channelid: channel.channelid }, 2)
            .then((res) => {
              loading.clear();
              t.data.datas.splice(t.itemmenu_index, 1);
            })
            .catch((error) => {
              loading.clear();
              Toast("网络异常，请稍后重试");
            });
        })
        .catch(() => {});
    },
    //启用or停用
    enableDis(index, status) {
      var t = this;
      t.itemmenu_show = false;
      var channel = t.data.datas[t.itemmenu_index];
      t.data.datas[t.itemmenu_index].loading = true;
      setTimeout(() => {
        t.$http
        .post(
          "/Channel/EnableChannel",
          { channelid: channel.channelid, isenable: status },
          2
        )
        .then((res) => {
          t.data.datas[t.itemmenu_index].loading = false;
          t.data.datas[t.itemmenu_index].isenable = status;
        })
        .catch((error) => {
          t.data.datas[t.itemmenu_index].loading = false;
          Toast("网络异常，请稍后重试");
        });
      }, 100);
    },
    onLoad() {
      var t = this;
      console.log("onLoad", t.data.page);
      t.data.loading = true;
      t.$http
        .get(
          "/Channel/GetChannels",
          { pageindex: t.data.page, pagesize: 15, isdefault: true },
          2
        )
        .then((res) => {
          t.data.loading = false;
          console.log("GetDisUsers", res);
          if (res.resultState == 1) {
            t.data.datas = t.data.datas.concat(res.Data.datas);
            t.data.page += 1;
            if (res.Data.datas.length < 15) t.data.finished = true;
          } else {
            t.data.finished = true;
            vant.Toast(res.errorMsg);
          }
          console.log("t.data.finished", t.data.finished);
        })
        .catch((error) => {});
    },
  },
  components: {lu_actiondetail},
  computed: {},
  created() {},
  mounted() {},
};
</script>

<style scoped lang="scss" src="../../static/scss/dislist.scss"></style>
<!-- Add "scoped" attribute to limit CSS to this component only <style scoped  lang="scss" src="../../static/scss/shareindex.scss"></style>-->
